import { Component, OnInit } from '@angular/core';
import { CarsysService } from 'src/app/services/http/carsys.service';
import { FormGroup, FormControl } from '@angular/forms';
import { distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { UtilMasks } from 'src/app/utils/util-masks';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { LoginService } from 'src/app/services/login.service';
import { first } from 'rxjs/operators';
import { Usuario } from 'src/app/models/usuario-login';
import { DateUtil } from 'src/app/utils/date.util';

@Component({
  selector: 'app-list-laudo-carsys',
  templateUrl: './list-laudo-carsys.component.html',
  styleUrls: ['./list-laudo-carsys.component.scss']
})
export class ListLaudoCarsysComponent implements OnInit {

  usuario: Usuario;
  tableLoading:boolean = false;
  listaResultado = [];
  total:number= 0;
  pesquisaDataInicio: any;
  pesquisaDataFim: any;

  masks = {
    data: {mask: UtilMasks.dataBr, guide: false},
  }

  form = new FormGroup({
    entrada: new FormControl(''),
    laudo: new FormControl(''),
    produto: new FormControl(''),
    razaoSocial: new FormControl(''),
    unidade: new FormControl(''),
  });

  params = {
    filter: {
      dataFim: '',
      dataInicio: '',
      entrada: '',
      laudo: '',
      produto: '',
      razaoSocial: '',
      unidade: '',
    },
    sorting: {
      idClienteCarsys: '',
      unidade: '',
      razaoSocial: '',
      placa: '',
      chassi: '',
      dataConsulta: 'desc',
      produto: '',
    },
    data: new Date(),
    per_page: 10,
    page: 1
  }

  first: number = 0;
  object: any = {};
  dynamicdownloadName: string = "Laudos Carsys"
  
  cols: any = [
    { field: 'idCarsys', header: 'Unidade' },
    { field: 'razaoSocial', header: 'Razão social' },
    { field: 'placaPrint', header: 'Placa' },
    { field: 'chassi', header: 'Chassi' },
    { field: 'dataConsultaPrint', header: 'Data' },
    { field: 'produto', header: 'Produto' },
  ];

  constructor(private loginService: LoginService, private carsysService: CarsysService, private msgService: ModalMsgService) {
    this.loginService.getLogIn().pipe(first()).subscribe(u => this.usuario = u);
   }

  ngOnInit() {
    this.updateResult();

    this.form.valueChanges.pipe(distinctUntilChanged(), debounceTime(800)).subscribe(r => {
      this.params.filter = {...this.params.filter, ...r};
      this.updateResult();
    });
  }

  changeOrder() {
    this.updateResult();
  }

  setPageSize(size) {
    this.params.per_page = size;
    this.updateResult();
  }

  nextPage() {
    this.updateResult();
  }

  updateResult(){
    this.params.data = new Date();
    this.carsysService.listaRelatorios(this.params).then(r => {
      this.total = r.total || 0;
      this.listaResultado = r.lista || [];
      this.insertModePrint();
    });
  }

  excluirLaudo(laudo) {
    this.msgService.open('Deseja remover o Laudo Carsys: ' + laudo.idClienteCarsys, '', 'warning').then(r => {
      if(r == 'ok') {
        this.carsysService.excluirLaudo(laudo).then(r => {
          this.updateResult();
        });
      }
    }).catch(r => {});
  }
  
  setDataInicio(date, update = true) {
    this.params.filter.dataInicio = new Date(
      date.year,
      date.month - 1,
      date.day,
      0, 0, 0, 0
    ).toISOString();
    this.pesquisaDataInicio = date;
    if (update) this.updateResult();
  }

  setDataFim(date, update = true) {
    this.params.filter.dataFim = new Date(
      date.year,
      date.month - 1,
      date.day,
      23, 59, 59, 0
    ).toISOString();
    this.pesquisaDataFim = date;
    if (update) this.updateResult();
  }

  private printDateForCSV(date: Date): string {
    return DateUtil.dateTypeFormatStr2(new Date(date));
  }

 insertModePrint() {
    this.listaResultado.map(consulta => {
      consulta.dataConsultaPrint = this.printDateForCSV(consulta.dataConsulta)
      consulta.placaPrint = this.printPlaca(consulta.placa);
    })
  }

  printPlaca(value: string): string {
    let newValue:string = (value || '').toString().toUpperCase().replace('-','').trim();
    let arrayValue = newValue.split('');
    if(arrayValue.length>3) {
      arrayValue.splice(2, 1, arrayValue[2] + '-');
      newValue = arrayValue.join('');
    }
    return newValue;
  }

}
